<!-- <p>recent-vouchers works!</p> -->
<!-- Card -->

<div class="mainCard shadow brdrRadius3" id="favLed=true" style="padding: 0px 0px 7px 0px;">
  <!-- Card Header -->
  <div class="mainCardHeader">
    <div class="{{isGalaxyFoldMobile ? 'header80Per' : 'header59Per'}}" style="display: inline-block; text-align: left; font-weight: 600; font-size: 20px; vertical-align: middle;">
      Favourite Ledgers
    </div>
    <div class="{{isGalaxyFoldMobile ? 'width20' : 'width40'}}" style="display: inline-block; text-align: right; line-height: 40px;">
      <input type="text" *ngIf="isShowSearch" [(ngModel)]="search" class="form-control wid39"
        style="width: 61%; display: inline-block;font-size: 13px;" autofocus />
      <span class="searchBtn" (click)="isShowSearch = !isShowSearch" *ngIf="favLedger.length > 0" title="Search" style="display: none;">
        <i class="fa fa-search headerIcon" aria-hidden="true"></i>
      </span>
      <span class="btn darkBlueButton mrgRght10 webView" title="Show Ledger View" (click)="openLedger(null)" style="cursor: pointer;"> 
        <i class="fa fa-search" style="margin-right: 5px;" aria-hidden="true"></i> Find Ledger
      </span>
      <span class="mrgRght10 mobView" title="Show Ledger View" (click)="openLedger(null)" style="font-size: 13px; line-height: 1.66em; vertical-align: middle;"> 
        <i class="fa fa-search" style="margin-right: 5px;" aria-hidden="true"></i>
      </span>
      <span class="expandBtn brdrRadius3" *ngIf="favLedger.length > 0" title="Expand" (click)="expoanTable(expandModal)" style="vertical-align: middle;">
        <i class="fa fa-expand headerIcon webView" aria-hidden="true"></i>
      </span>

      <span class="gotoLdrBtn" title="Show Ledger View" (click)="openLedger(null)" style="display: none;"> <!-- *ngIf="favLedger.length > 0" -->
        <i class="fa fa-list headerIcon webView" aria-hidden="true"></i>
      </span>     
    </div>
  </div>

  <!-- Card Header -->
  <div class="mainCardBody">
    <div *ngIf="favLedger.length > 0">
      <div *ngFor="let f of favLedger | filter:'name':search; let i = index; let l = last"
        class="col-md-12 col-sm-12 col-12 pad0 mainCardItem"
        style="{{ i == 0 ? 'border-top: 1px solid #ddd;' : ''}} {{ !l ? 'border-bottom: 1px solid #ddd;' : ''}}">
        <div class="col-md-6 col-sm-6 col-6 pad0"
          style="cursor: pointer; text-align: left; display: inline-block; font-weight: {{ f.isHead == true ? '600' : 'normal'}}; cursor: pointer; color: {{ f.isHead == true ? '#E88421' : '#1F628E'}}; font-size: 13px;">
          <span (click)="openLedger(f)">{{f.name}}</span> <i class="fa {{f.isFav ? 'fa-star' : 'fa-star-o'}}"
            aria-hidden="true" style="margin-left: 10px; color: #DAA520;" *ngIf="f.isHead == false"
            (click)="f.isFav = !f.isFav; removeFav(i)"></i>
        </div>
        <div class="col-md-6 col-sm-6 col-6 pad0 font13" style="text-align: right; display: inline-block;">
          {{f.ClosingBal | cRDB}}
        </div>
      </div>
    </div>
    <div class="col-md-12 col-sm-12 col-12" *ngIf="favLedger.length == 0">
      <span class="nrf brdrRadius3" style="margin: 10px 0px;">Click <i class="fa fa-star-o" aria-hidden="true"></i> next to the name
        of a ledger to mark it as favourite. </span>
    </div>
  </div>
</div>

<!--Expand Modal-->
<ng-template #expandModal let-modal>
  <!--Header-->
  <div class="modal-header">
    <div class="col-md-12 col-sm-12 col-12">
      <div class="row">
        <div class="col-md-9 col-sm-10 col-10" style="padding-left: 0px;">
          <h4 class="modal-title"><span id="ApntmntHdr">Favourite Ledgers</span></h4>
        </div>
        <div class="col-md-3 col-sm-2 col-2" style="padding: 0px;">
          <i class="closeMdl zmdi zmdi-close" data-dismiss="modal" style="float: right;"
            (click)="modal.dismiss('Cross click')"></i>
        </div>
      </div>
    </div>
  </div>
  <!--Body-->
  <div class="modal-body" style="padding-top: 0px; overflow-y: auto;">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="name">
        <th class="header" mat-header-cell *matHeaderCellDef style="padding: 0px 10px 0px 0px;">
          <div class="filter" floatLabel="never">
            <input matInput class="form-control brdrColor formCtlFltr brdrRadius3" [formControl]="NameFilter" placeholder="Name"
              style="border: none; border-bottom: 1px solid; font-size: 14px; width: 200px;">
          </div>
        </th>
        <td mat-cell *matCellDef="let person" style="color: #15304a">
          {{person.name}}</td>
      </ng-container>

      <ng-container matColumnDef="currentBal">
        <th class="header" mat-header-cell *matHeaderCellDef style="padding: 0px 10px;">
          <div class="filter" floatLabel="never" style="width: 100%;">
            <input matInput class="form-control brdrColor formCtlFltr brdrRadius3" [formControl]="currentBalFilter"
              placeholder="Opening Balance" style="border: none; border-bottom: 1px solid; font-size: 14px;">
          </div>
        </th>
        <td mat-cell *matCellDef="let person" style="text-align: right; width: 90%;">{{person.currentBal | cRDB}}</td>
      </ng-container>

      <ng-container matColumnDef="ClosingBal">
        <th class="header" mat-header-cell *matHeaderCellDef style="padding: 0px 10px;">
          <div class="filter" floatLabel="never" style="width: 130px;">
            <input matInput class="form-control brdrColor formCtlFltr brdrRadius3" [formControl]="ClosingBalFilter"
              placeholder="Closing Balance" style="border: none; border-bottom: 1px solid; font-size: 14px;">
          </div>
        </th>
        <td mat-cell *matCellDef="let person" style="text-align: right;">{{person.ClosingBal | cRDB}}</td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let person; columns: displayedColumns"></tr>
    </table>
    <div *ngIf="dataSource.filteredData.length === 0">
      <div class="nrf" style="margin-top: 10px;">No records found!</div>
    </div>
  </div>
  <!--Footer-->
  <!-- <div class="" style="padding: 15px; border: none; text-align: left; float: left;">
          <span class="btn btn-save" style="padding: 2px 10px 2px;" (click)="saveLedger()">
              <i class="zmdi zmdi-check" style="margin-right: 5px;"></i>
              <span>Save</span>
          </span>
      </div> -->
</ng-template>

<div class="mainCard shadow webView brdrRadius3 " style="padding-bottom: 15px;border-radius: 10px; 
margin-top: 15px;" *ngIf="right.Accts && right.AcctsVchrEntry">
  <div class="col-md-12 col-sm-12 col-xs-12" style="display: inline-block;padding: 0px !important;">

    <div
      style="border-bottom: 1px solid rgb(221, 221, 221);display: inline-block; margin-bottom: 15px; padding: 15px; width: 100%; text-align: left; font-weight: 600; font-size: 20px;">
      Quick Access
    </div>
    <!-- 
    <div
      style="border-bottom: 1px solid rgb(221, 221, 221);display: inline-block; margin-bottom: 15px; padding: 15px; width: 100%; text-align: left; font-weight: 600; font-size: 20px;">
      Quick Access
    </div> -->
    
    <a class="btn darkBlueButton webView width47" [routerLink]="['/balanceSheet']" target="{{isWeb ? '_blank' : '_self'}}" style="margin-left: 20px; text-decoration: none; box-shadow: none !important;width: 31%;" title="Balance Sheet"
      *ngIf="right.Accts">
      <i class="fa fa-balance-scale headerIcon" style="margin-right: 5px;" aria-hidden="true"></i> Balance Sheet
    </a>

     <a class="btn btn-darkBlue mobView width47" [routerLink]="['/balanceSheet']" target="{{isWeb ? '_blank' : '_self'}}" style="padding: 4px 14px 4px 14px; font-size: 13px; line-height: 1.66em; 
    margin-left: 20px; text-decoration: none; box-shadow: none !important;width: 31%;" title="Balance Sheet"
      *ngIf="right.Accts">
      <i class="fa fa-balance-scale headerIcon" style="margin-right: 5px;" aria-hidden="true"></i> Balance Sheet
    </a> 

    <a class="btn darkBlueButton webView width42" [routerLink]="['/profitandLoss']" target="{{isWeb ? '_blank' : '_self'}}"
     style=" margin-left: 10px; text-decoration: none; box-shadow: none !important;width: 28%"
      title="Profit & Loss" *ngIf="right.Accts">
      <i class="zmdi zmdi-format-valign-center headerIcon" style="margin-right: 5px;" aria-hidden="true"></i> Profit & Loss
    </a>

     <a class="btn btn-blue mobView width42" [routerLink]="['/profitandLoss']" target="{{isWeb ? '_blank' : '_self'}}" style="padding: 4px 14px 4px 14px; font-size: 13px;  line-height: 1.66em; 
                        margin-left: 10px; text-decoration: none; box-shadow: none !important;width: 28%"
      title="Profit & Loss" *ngIf="right.Accts">
      <i class="fa fa-file-text-o headerIcon" style="margin-right: 5px;" aria-hidden="true"></i> Profit & Loss
    </a> 

    <a class="btn darkBlueButton webView width47" [routerLink]="['/trialBalance']" target="{{isWeb ? '_blank' : '_self'}}"
     style="margin-left: 10px; width: 28%;" title="Trial Balance"
      *ngIf="right.Accts ">
      <i class="fa fa-file headerIcon" style="margin-right: 5px;" aria-hidden="true"></i> Trial Balance
    </a>

     <a class="btn btn-teal mobView width47" [routerLink]="['/trialBalance']" target="{{isWeb ? '_blank' : '_self'}}" style="display:none;padding: 4px 14px 4px 14px; font-size: 13px;  line-height: 1.66em; 
    margin-left: 10px; text-decoration: none; box-shadow: none !important;width: 29%;" title="Trial Balance"
      *ngIf="right.Accts ">
      <i class="fa fa-file headerIcon" style="margin-right: 5px;" aria-hidden="true"></i> Trial Balance
    </a> 

    <!-- GST Ledgers Configuration Button -->
    <div class="btn darkGreenButton webView width42" (click)="GSTLedgerModal()" title="GST Ledgers" 
      *ngIf="right.AcctsCfg && !isGSTLedgersConfigured" style="margin-left: 20px; margin-top: 13px; width: 31%">
      <i class="zmdi zmdi-city headerIcon" style="margin-right: 5px;" aria-hidden="true"></i>GST Ledgers
    </div>

    <!-- GSTR-3B Button -->
    <div class="btn darkGreenButton webView width42" (click)="redirectToGSTR3B()" title="GSTR-3B" 
      *ngIf="right.AcctsCfg && isGSTLedgersConfigured" style="margin-left: 20px; margin-top: 13px; width: 31%">
      <i class="zmdi zmdi-city headerIcon" style="margin-right: 5px;" aria-hidden="true"></i>GSTR-3B
    </div>

     <div class="btn btn-orange mobView width42" (click)="open(mymodal)" style="padding: 4px 14px 4px 14px; font-size: 13px; line-height: 1.66em; 
    margin-left: 25px; text-decoration: none; box-shadow: none !important; margin-top: 13px; width: 29%"
      *ngIf="right.AcctsVchrEntry" title="Enter Voucher">
      <i class="zmdi zmdi-plus headerIcon" style="margin-right: 5px;" aria-hidden="true"></i>Enter Voucher
    </div> 

    <a class="btn darkGreenButton webView width47" [routerLink]="['/Reconciliation']" target="{{isWeb ? '_blank' : '_self'}}"
      style="margin-left: 10px;margin-top: 13px;width: 28%" title="Reconciliation" *ngIf="right.Accts">
      <i class="fa fa-inr headerIcon" style="margin-right: 5px;" aria-hidden="true"></i>Reconciliation
    </a>

     <a class="btn btn-yellow mobView width47" [routerLink]="['/Reconciliation']" target="{{isWeb ? '_blank' : '_self'}}"
      style="display:none;padding: 4px 14px 4px 14px; font-size: 13px;  line-height: 1.66em; 
                        margin-left: 15px; text-decoration: none; box-shadow: none !important;margin-top: 13px;width: 29%" title="Reconciliation" *ngIf="right.Accts">
      <i class="fa fa-inr headerIcon" style="margin-right: 5px;" aria-hidden="true"></i>Reconciliation
    </a> 

    <a class="btn darkGreenButton webView width42" [routerLink]="['/dailyStock']" target="{{isWeb ? '_blank' : '_self'}}"
      style="margin-left: 10px; margin-top: 13px; width: 28%" title="Stock Value" *ngIf="right.AcctsCfg">
      <i class="zmdi zmdi-widgets headerIcon" style="margin-right: 5px;" aria-hidden="true"></i>Stock Value
    </a>

     <a class="btn btn-green mobView width42" [routerLink]="['/dailyStock']" target="{{isWeb ? '_blank' : '_self'}}"
      style="display:none;padding: 4px 14px 4px 14px; font-size: 13px; line-height: 1.60em;
                      margin-left: 20px; text-decoration: none; box-shadow: none !important; margin-top: 13px; width: 26%" title="Stock Value" *ngIf="right.AcctsCfg">
      <i class="zmdi zmdi-widgets headerIcon" style="margin-right: 5px;" aria-hidden="true"></i>Stock Value
    </a> 

    <!-- Purchase Orders-->
    <a class="btn darkGreenButton webView width42" href="../../main.html#/Docs?M=8" target="{{isWeb ? '_blank' : '_self'}}" *ngIf="right.POEntry"
      style="margin-left: 20px;margin-top: 13px; width: 31%" title="Purchase Orders">
      <i class="fa fa-file-text-o headerIcon" style="margin-right: 5px;" aria-hidden="true"></i>Purchase Orders
    </a>

     <!-- Credit Notes -->
     <a class="btn darkGreenButton webView width42" href="../../main.html#/Docs?M=4" target="{{isWeb ? '_blank' : '_self'}}"
      style="margin-left: 10px;  margin-top: 13px; width: 28%" title="Credit Notes" *ngIf="right.InvoiceView">
      <i class="zmdi zmdi-balance-wallet headerIcon" style="margin-right: 5px;" aria-hidden="true"></i>Credit Notes
    </a>

    <!-- Debit Notes -->
    <a class="btn darkGreenButton webView width42" href="../../main.html#/Docs?M=5" target="{{isWeb ? '_blank' : '_self'}}"
      style=" margin-left: 10px; text-decoration: none;margin-top: 13px; width: 28%" title="Debit Notes" *ngIf="right.InvoiceView">
      <i class="fa fa-money headerIcon" style="margin-right: 5px;" aria-hidden="true"></i>Debit Notes
    </a>

    <!--Voucher Entry Modal-->
    <ng-template #mymodal let-modal>
      <div class="modal-body" style="padding: 0px;">
        <app-voucher-entry (oncloseVchrModal)="closeModal($event)"></app-voucher-entry>
      </div>
    </ng-template>
  </div>
</div>

<div class="mainCard shadow mobView " style="padding-bottom: 15px;border-radius: 3px;
    margin-top: 15px;" *ngIf="right.Accts && right.AcctsVchrEntry">
  <div class="col-md-12 col-sm-12 col-xs-12" style="display: inline-block;padding: 0px !important;">

    <div
      style="border-bottom: 1px solid rgb(221, 221, 221);display: inline-block; margin-bottom: 0px; padding: 15px; width: 100%; text-align: left; font-weight: 600; font-size: 20px;">
      Quick Access
    </div>

    <!-- <a class="btn btn-darkBlue webView " [routerLink]="['/balanceSheet']" target="{{isWeb ? '_blank' : '_self'}}" style="padding: 4px 14px 4px 14px; font-size: 13px; line-height: 1.66em; 
      margin-left: 20px; text-decoration: none; box-shadow: none !important;" title="Balance Sheet"
      *ngIf="right.Accts">
      <i class="fa fa-balance-scale headerIcon" style="margin-right: 5px;" aria-hidden="true"></i> Balance Sheet
    </a> -->

    <a class="btn btn-darkBlue mobView brdrRadius3  {{isGalaxyFoldMobile ? 'wid90Per' : 'width47'}}" [routerLink]="['/balanceSheet']" target="{{isWeb ? '_blank' : '_self'}}" style="padding: 4px 14px 4px 14px; font-size: 13px; line-height: 1.66em; 
     text-decoration: none; box-shadow: none !important;" title="Balance Sheet"
      *ngIf="right.Accts">
      <i class="fa fa-balance-scale headerIcon" style="margin-right: 5px;" aria-hidden="true"></i> Balance Sheet
    </a>

    <!-- <a class="btn btn-blue webView width42" [routerLink]="['/profitandLoss']" target="{{isWeb ? '_blank' : '_self'}}" style="padding: 4px 14px 4px 14px; font-size: 13px;  line-height: 1.66em; 
                        margin-left: 10px; text-decoration: none; box-shadow: none !important;width: 28%"
      title="Profit & Loss" *ngIf="right.Accts">
      <i class="fa fa-file-text-o headerIcon" style="margin-right: 5px;" aria-hidden="true"></i> Profit & Loss
    </a> -->

    <a class="btn btn-darkBlue mobView brdrRadius3 {{isGalaxyFoldMobile ? 'wid90Per' : 'width42'}}" [routerLink]="['/profitandLoss']" target="{{isWeb ? '_blank' : '_self'}}" style="padding: 4px 14px 4px 14px; font-size: 13px;  line-height: 1.66em; 
                        text-decoration: none; box-shadow: none !important;"
      title="Profit & Loss" *ngIf="right.Accts">
      <i class="zmdi zmdi-format-valign-center headerIcon" style="margin-right: 5px;" aria-hidden="true"></i> Profit & Loss
    </a>

    <!-- <a class="btn btn-teal webView width47" [routerLink]="['/trialBalance']" target="{{isWeb ? '_blank' : '_self'}}" style="padding: 4px 14px 4px 14px; font-size: 13px;  line-height: 1.66em; 
        margin-left: 10px; text-decoration: none; box-shadow: none !important;width: 29%;" title="Trial Balance"
      *ngIf="right.Accts ">
      <i class="fa fa-file headerIcon" style="margin-right: 5px;" aria-hidden="true"></i> Trial Balance
    </a> -->

    <a class="btn btn-darkBlue mobView brdrRadius3 {{isGalaxyFoldMobile ? 'wid90Per' : 'width47'}}" [routerLink]="['/trialBalance']" target="{{isWeb ? '_blank' : '_self'}}" style="display:none;padding: 4px 14px 4px 14px; font-size: 13px;  line-height: 1.66em; 
    text-decoration: none; box-shadow: none !important;" title="Trial Balance"
      *ngIf="right.Accts ">
      <i class="fa fa-file headerIcon" style="margin-right: 5px;" aria-hidden="true"></i> Trial Balance
    </a>


    <!-- GST Ledgers Configuration Button - Mobile -->
    <div class="btn btn-darkBlue mobView brdrRadius3 {{isGalaxyFoldMobile ? 'wid90Per' : 'width47'}}" (click)="GSTLedgerModal()" title="GST Ledgers" 
      *ngIf="right.AcctsCfg && !isGSTLedgersConfigured" style="padding: 4px 14px 4px 14px; font-size: 13px; line-height: 1.66em; 
        text-decoration: none; box-shadow: none !important;">
      <i class="zmdi zmdi-city headerIcon" style="margin-right: 5px;" aria-hidden="true"></i>GST Ledgers
    </div>

    <!-- GSTR-3B Button - Mobile -->
    <div class="btn btn-darkBlue mobView brdrRadius3 {{isGalaxyFoldMobile ? 'wid90Per' : 'width47'}}" (click)="redirectToGSTR3B()" title="GSTR-3B" 
      *ngIf="right.AcctsCfg && isGSTLedgersConfigured" style="padding: 4px 14px 4px 14px; font-size: 13px; line-height: 1.66em; 
        text-decoration: none; box-shadow: none !important;">
      <i class="zmdi zmdi-city headerIcon" style="margin-right: 5px;" aria-hidden="true"></i>GSTR-3B
    </div>

    <!-- Purchase Orders -->
    <a class="btn btn-darkBlue brdrRadius3 mobView {{isGalaxyFoldMobile ? 'wid90Per' : 'width42'}}" href="../../main.html#/Docs?M=8" target="{{isWeb ? '_blank' : '_self'}}" style="padding: 4px 14px 4px 14px; font-size: 13px; line-height: 1.66em; 
    text-decoration: none; box-shadow: none !important;" title="Purchase Orders" *ngIf="right.POEntry">
      <i class="fa fa-file-text-o headerIcon" style="margin-right: 5px;" aria-hidden="true"></i> POs
    </a>


    <!-- Credit Notes -->
    <a class="btn btn-darkBlue  brdrRadius3 mobView {{isGalaxyFoldMobile ? 'wid90Per' : 'width47'}}" href="../../main.html#/Docs?M=4" target="{{isWeb ? '_blank' : '_self'}}" style="padding: 4px 14px 4px 14px; font-size: 13px; line-height: 1.66em; 
          text-decoration: none; box-shadow: none !important;" title="Credit Notes" *ngIf="right.InvoiceView">
      <i class="zmdi zmdi-balance-wallet headerIcon" style="margin-right: 5px;" aria-hidden="true"></i> Credit Notes
    </a>

    <!-- Debit Notes -->
    <a class="btn btn-darkBlue brdrRadius3 mobView {{isGalaxyFoldMobile ? 'wid90Per' : 'width42'}}" href="../../main.html#/Docs?M=5" target="{{isWeb ? '_blank' : '_self'}}" style="padding: 4px 14px 4px 14px; font-size: 13px; line-height: 1.66em; 
          text-decoration: none; box-shadow: none !important;" title="Debit Notes" *ngIf="right.InvoiceView">
      <i class="fa fa-money headerIcon" style="margin-right: 5px;" aria-hidden="true"></i> Debit Notes
    </a>

    <!-- Purchase Invoice -->
    <a class="btn darkGreenButton brdrRadius3 mobView {{isGalaxyFoldMobile ? 'wid90Per' : 'width47'}}" href="../../main.html#/Docs?M=6" target="{{isWeb ? '_blank' : '_self'}}" style="padding: 4px 14px 4px 14px; font-size: 13px; line-height: 1.66em; 
    text-decoration: none; box-shadow: none !important;" title="Purchases" *ngIf="right.InvoiceView">
      <i class="fa fa-file-text-o headerIcon" style="margin-right: 5px;" aria-hidden="true"></i> Purchases
    </a>

    <!-- Sales Invoice -->
    <a class="btn darkGreenButton mobView {{isGalaxyFoldMobile ? 'wid90Per' : 'width42'}}" href="../../main.html#/Invoices" target="{{isWeb ? '_blank' : '_self'}}" style="padding: 4px 14px 4px 14px; font-size: 13px; line-height: 1.66em; 
    text-decoration: none; box-shadow: none !important;" title="Sales" *ngIf="right.InvoiceView">
      <i class="fa fa-file-text-o headerIcon" style="margin-right: 5px;" aria-hidden="true"></i> Sales
    </a>

    <!--Voucher Entry Modal-->
    <ng-template #mymodal let-modal>
      <div class="modal-body" style="padding: 0px;">
        <app-voucher-entry (oncloseVchrModal)="closeModal($event)"></app-voucher-entry>
      </div>
    </ng-template>
  </div>
</div>


